/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Note_Create_PlhInputs */

const vi_pl_note_create_plh = /** @type {(inputs: Pl_Note_Create_PlhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu lấy hàng`)
};

/**

* @param {Pl_Note_Create_PlhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_note_create_plh = /** @type {((inputs?: Pl_Note_Create_PlhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Note_Create_PlhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_note_create_plh(inputs)
});